import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Row, Col, Spin, Alert, Typography, Empty } from 'antd';
import VehicleCard from '../components/VehicleCard';
import { customerAPI } from '../services/api';
import './CatalogList.css';

const { Title, Text } = Typography;

const CatalogList = () => {
  const { catalogId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [catalog, setCatalog] = useState(null);
  const [vehicles, setVehicles] = useState([]);

  const fetchCatalog = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await customerAPI.getCatalog(catalogId);

      if (response.data.success) {
        setCatalog(response.data.data.catalog);
        setVehicles(response.data.data.vehicles);
      } else {
        setError('Failed to load catalogue');
      }
    } catch (err) {
      console.error('Error fetching catalog:', err);
      setError(err.response?.data?.message || 'Catalogue not found');
    } finally {
      setLoading(false);
    }
  }, [catalogId]);

  useEffect(() => {
    fetchCatalog();
  }, [fetchCatalog]);

  const handleVehicleClick = (vehicle) => {
    navigate(`/catalog/${catalogId}/vehicle/${vehicle.id}`);
  };

  if (loading) {
    return (
      <div className="catalog-loading">
        <Spin size="large" tip="Loading vehicles..." />
      </div>
    );
  }

  if (error) {
    return (
      <div className="catalog-error">
        <Alert
          message="Error"
          description={error}
          type="error"
          showIcon
        />
      </div>
    );
  }

  if (!catalog || vehicles.length === 0) {
    return (
      <div className="catalog-empty">
        <Empty
          description="No vehicles found in this catalogue"
        />
      </div>
    );
  }

  return (
    <div className="catalog-container">
      {/* Header */}
      <div className="catalog-header">
        <div className="catalog-header-content">
          <img
            src="/logo.png"
            alt="Xoom Drives"
            style={{ height: 60, marginBottom: 8 }}
          />
          <Text className="catalog-subtitle">
            {vehicles.length} {vehicles.length === 1 ? 'Vehicle' : 'Vehicles'} Available
          </Text>
        </div>
      </div>

      {/* Vehicle Grid */}
      <div className="catalog-content">
        <Row gutter={[16, 16]}>
          {vehicles.map((vehicle) => (
            <Col
              key={vehicle.id}
              xs={24}
              sm={12}
              md={8}
              lg={6}
            >
              <VehicleCard
                vehicle={vehicle}
                onClick={handleVehicleClick}
                showPrice={catalog.showPrices}
              />
            </Col>
          ))}
        </Row>
      </div>

      {/* Footer */}
      <div className="catalog-footer">
        <img
          src="/logo.png"
          alt="Xoom Drives"
          style={{ height: 30 }}
        />
      </div>
    </div>
  );
};

export default CatalogList;
